module.exports = __webpack_public_path__ + "static/media/kwalifikacje.3a790082.png";